
export default function Hero() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/030480cdba3eb2a7e2713d1b9db9aaea.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-left max-w-3xl">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Hayalinizdeki Mobilyalar<br />
            <span className="text-amber-400">Olmez Mobilya</span> ile Gerçek Oluyor
          </h2>
          <p className="text-xl text-gray-100 mb-8 leading-relaxed">
            Mutfak dolabı, gardırop, yatak odası takımı ve daha fazlası... 
            Uzman ekibimiz ve kaliteli işçiliğimizle evinize değer katıyoruz.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#products"
              className="bg-amber-600 text-white px-8 py-4 rounded-lg hover:bg-amber-700 transition-colors duration-200 text-center font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              Ürünlerimizi Keşfedin
            </a>
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-amber-700 px-8 py-4 rounded-lg hover:bg-gray-100 transition-colors duration-200 flex items-center justify-center gap-2 font-semibold text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Hemen İletişime Geçin
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
